// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: Raleway, sans-serif;
}

.screen {
  background: linear-gradient(90deg, #5D54A4, #7C78B8);
  position: relative;
  height: 600px;
  width: 360px;
  box-shadow: 0px 0px 24px #5C5696;
}

.screen__content {
  z-index: 1;
  position: relative;
  height: 100%;
}

.screen__background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  clip-path: inset(0 0 0 0);
}

.screen__background__shape {
  transform: rotate(45deg);
  position: absolute;
}

.screen__background__shape1 {
  height: 520px;
  width: 520px;
  background: #FFF;
  top: -50px;
  right: 120px;
  border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
  height: 220px;
  width: 220px;
  background: #6C63AC;
  top: -172px;
  right: 0;
  border-radius: 32px;
}

.screen__background__shape3 {
  height: 540px;
  width: 190px;
  background: linear-gradient(270deg, #5D54A4, #6A679E);
  top: -24px;
  right: 0;
  border-radius: 32px;
}

.screen__background__shape4 {
  height: 400px;
  width: 200px;
  background: #7E7BB9;
  top: 420px;
  right: 50px;
  border-radius: 60px;
}

.login {
  width: 320px;
  padding: 30px;
  padding-top: 156px;
}

.login__field {
  padding: 20px 0px;
  position: relative;
}

.login__icon {
  position: absolute;
  top: 30px;
  color: #7875B5;
}

.login__input {
  border: none;
  border-bottom: 2px solid #D1D1D4;
  background: none;
  padding: 10px;
  padding-left: 24px;
  font-weight: 700;
  width: 75%;
  transition: 0.2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
  outline: none;
  border-bottom-color: #6A679E;
}

.login__submit {
  background: #fff;
  font-size: 14px;
  margin-top: 30px;
  padding: 16px 20px;
  border-radius: 26px;
  border: 1px solid #D4D3E8;
  font-weight: 700;
  display: flex;
  align-items: center;
  width: 100%;
  color: #4C489D;
  box-shadow: 0px 2px 2px #5C5696;
  cursor: pointer;
  transition: 0.2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
  border-color: #6A679E;
  outline: none;
}

.button__icon {
  font-size: 24px;
  margin-left: auto;
  color: #7875B5;
}

.social-login {
  position: absolute;
  height: 140px;
  width: 160px;
  text-align: center;
  bottom: 0px;
  right: 0px;
  color: #fff;
}

.social-icons {
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-login__icon {
  padding: 20px 10px;
  color: #fff;
  text-decoration: none;
  text-shadow: 0px 0px 8px #7875B5;
}

.social-login__icon:hover {
  transform: scale(1.5);
}`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPasswordPage/ForgotPasswordPage.style.scss"],"names":[],"mappings":"AAEA;EACC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AAAD;;AAcA;EACC,oDAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;AAXD;;AAcA;EACC,UAAA;EACA,kBAAA;EACA,YAAA;AAXD;;AAcA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EAEA,yBAAA;AAXD;;AAcA;EACC,wBAAA;EACA,kBAAA;AAXD;;AAcA;EACC,aAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAXD;;AAcA;EACC,aAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;AAXD;;AAcA;EACC,aAAA;EACA,YAAA;EACA,qDAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;AAXD;;AAcA;EACC,aAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAXD;;AAcA;EACC,YAAA;EACA,aAAA;EACA,kBAAA;AAXD;;AAcA;EACC,iBAAA;EACA,kBAAA;AAXD;;AAcA;EACC,kBAAA;EACA,SAAA;EACA,cAAA;AAXD;;AAcA;EACC,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AAXD;;AAcA;;;EAGC,aAAA;EACA,4BAAA;AAXD;;AAcA;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAZD;;AAeA;;;EAGC,qBAAA;EACA,aAAA;AAZD;;AAeA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AAZD;;AAeA;EACC,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAZD;;AAeA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAZD;;AAeA;EACC,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gCAAA;AAZD;;AAeA;EACC,qBAAA;AAZD","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Raleway:400,700');\n\n* {\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\t\n\tfont-family: Raleway, sans-serif;\n}\n\n// body {\n// \tbackground: linear-gradient(90deg, #C7C5F4, #776BCC);\t\t\n// }\n\n// .container {\n// \tdisplay: flex;\n// \talign-items: center;\n// \tjustify-content: center;\n// \tmin-height: 100vh;\n// }\n\n.screen {\t\t\n\tbackground: linear-gradient(90deg, #5D54A4, #7C78B8);\t\t\n\tposition: relative;\t\n\theight: 600px;\n\twidth: 360px;\t\n\tbox-shadow: 0px 0px 24px #5C5696;\n}\n\n.screen__content {\n\tz-index: 1;\n\tposition: relative;\t\n\theight: 100%;\n}\n\n.screen__background {\t\t\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 0;\n\t-webkit-clip-path: inset(0 0 0 0);\n\tclip-path: inset(0 0 0 0);\t\n}\n\n.screen__background__shape {\n\ttransform: rotate(45deg);\n\tposition: absolute;\n}\n\n.screen__background__shape1 {\n\theight: 520px;\n\twidth: 520px;\n\tbackground: #FFF;\t\n\ttop: -50px;\n\tright: 120px;\t\n\tborder-radius: 0 72px 0 0;\n}\n\n.screen__background__shape2 {\n\theight: 220px;\n\twidth: 220px;\n\tbackground: #6C63AC;\t\n\ttop: -172px;\n\tright: 0;\t\n\tborder-radius: 32px;\n}\n\n.screen__background__shape3 {\n\theight: 540px;\n\twidth: 190px;\n\tbackground: linear-gradient(270deg, #5D54A4, #6A679E);\n\ttop: -24px;\n\tright: 0;\t\n\tborder-radius: 32px;\n}\n\n.screen__background__shape4 {\n\theight: 400px;\n\twidth: 200px;\n\tbackground: #7E7BB9;\t\n\ttop: 420px;\n\tright: 50px;\t\n\tborder-radius: 60px;\n}\n\n.login {\n\twidth: 320px;\n\tpadding: 30px;\n\tpadding-top: 156px;\n}\n\n.login__field {\n\tpadding: 20px 0px;\t\n\tposition: relative;\t\n}\n\n.login__icon {\n\tposition: absolute;\n\ttop: 30px;\n\tcolor: #7875B5;\n}\n\n.login__input {\n\tborder: none;\n\tborder-bottom: 2px solid #D1D1D4;\n\tbackground: none;\n\tpadding: 10px;\n\tpadding-left: 24px;\n\tfont-weight: 700;\n\twidth: 75%;\n\ttransition: .2s;\n}\n\n.login__input:active,\n.login__input:focus,\n.login__input:hover {\n\toutline: none;\n\tborder-bottom-color: #6A679E;\n}\n\n.login__submit {\n\tbackground: #fff;\n\tfont-size: 14px;\n\tmargin-top: 30px;\n\tpadding: 16px 20px;\n\tborder-radius: 26px;\n\tborder: 1px solid #D4D3E8;\n\t// text-transform: uppercase;\n\tfont-weight: 700;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tcolor: #4C489D;\n\tbox-shadow: 0px 2px 2px #5C5696;\n\tcursor: pointer;\n\ttransition: .2s;\n}\n\n.login__submit:active,\n.login__submit:focus,\n.login__submit:hover {\n\tborder-color: #6A679E;\n\toutline: none;\n}\n\n.button__icon {\n\tfont-size: 24px;\n\tmargin-left: auto;\n\tcolor: #7875B5;\n}\n\n.social-login {\t\n\tposition: absolute;\n\theight: 140px;\n\twidth: 160px;\n\ttext-align: center;\n\tbottom: 0px;\n\tright: 0px;\n\tcolor: #fff;\n}\n\n.social-icons {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.social-login__icon {\n\tpadding: 20px 10px;\n\tcolor: #fff;\n\ttext-decoration: none;\t\n\ttext-shadow: 0px 0px 8px #7875B5;\n}\n\n.social-login__icon:hover {\n\ttransform: scale(1.5);\t\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
